import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../components/ui/EmptyState';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <EmptyState
      title="Página não encontrada"
      description="Esse endereço não faz parte do PontoNow."
      action={<Button variant="contained" onClick={() => navigate('/ponto')}>Ir para o ponto</Button>}
    />
  );
}
